import React, { useState } from "react";
import { Editor, Toolbar } from "@wangeditor/editor-for-react";
import "@wangeditor/editor/dist/css/style.css";

export default function MyEditor({ onChange }) {
  const [editor, setEditor] = useState(null);
  const [html, setHtml] = useState(
    "<p><span style=‘color: rgb(51, 51, 51); background-color: rgb(255, 255, 255); font-size: 13px;’>山海T2是奇瑞旗下捷途汽车推出的一款旅行越野超混SUV车型，是一款混动版车型，是捷途汽车布局“旅行+混动越野”细分市场的全新产品，被视作捷途旅行者的插混版本。</span></p><p><img src='https://shopimg.jetour.com.cn/newweb/vehicles/shanhait2/kv/%E5%B1%B1%E6%B5%B7T2%E5%8E%BB%E6%8E%89%E4%BA%BA-pc.jpg' alt='汽车' data-href='https://shopimg.jetour.com.cn/newweb/vehicles/shanhait2/kv/%E5%B1%B1%E6%B5%B7T2%E5%8E%BB%E6%8E%89%E4%BA%BA-pc.jpg'/></p>"
  );
  console.log("html", html);
  return (
    <div style={{ border: "1px solid #ccc" }}>
      <Toolbar editor={editor} mode="default" />
      <Editor
        defaultConfig={{ placeholder: "请输入内容..." }}
        value={html}
        onCreated={setEditor}
        onChange={(editor) => {
          setHtml(editor.getHtml());
          onChange(editor.getHtml());
        }}
        mode="default"
        style={{ height: "500px" }}
      />
    </div>
  );
}
